import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nl from './locales/nl.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import { ticketTranslations } from './ticketTranslations';

// Simple language detector
const detectLanguage = () => {
  // First check localStorage
  let savedLanguage;
  try { savedLanguage = localStorage.getItem('language'); } catch { /* Private browsing may disable storage. */ }
  if (savedLanguage && ['nl', 'en', 'fr'].includes(savedLanguage)) {
    return savedLanguage;
  }
  // Then check browser language
  const browserLang = navigator.language?.split('-')[0];
  if (['nl', 'en', 'fr'].includes(browserLang)) {
    return browserLang;
  }
  return 'nl'; // Default to Dutch
};

i18n
  .use(initReactI18next)
  .init({
    lng: detectLanguage(),
    fallbackLng: 'nl',
    supportedLngs: ['nl', 'en', 'fr'],
    resources: {
      nl: { translation: { ...nl, ...ticketTranslations.nl } },
      en: { translation: { ...en, ...ticketTranslations.en } },
      fr: { translation: { ...fr, tickets: { ...fr.tickets, ...ticketTranslations.fr.tickets } } }
    },
    interpolation: {
      escapeValue: false // React already protects from XSS
    }
  });

const applyLanguage = language => {
  document.documentElement.lang = language;
  try { localStorage.setItem('language', language); } catch { /* Language still works in memory. */ }
};
i18n.on('languageChanged', applyLanguage);
applyLanguage(i18n.resolvedLanguage || i18n.language || 'nl');

export default i18n;
